import useLayout from "hooks/useLayout"
import SidebarRow from "../SidebarRow"
import { ReactComponent as HistoryIcon } from 'assets/icons/restore.svg'
import RightSidebar from "./RightSidebar"
import { useTranslation } from "react-i18next"
import SidebarGroup from "../sidebarGroup"

interface RightSidebarStorageProps {
    className?: string;
    children?: React.ReactNode;
    storageId?: string;
    categoryId?: string;
}

const RightSidebarStorage: React.FC<RightSidebarStorageProps> = ({ storageId }) => {

    const { t } = useTranslation()

    const {
        openDialog
    } = useLayout()

    // Return the sidebar component.
    return (
        <>
            <RightSidebar storageId={storageId}>
                <SidebarGroup title={t('titleStorage')} allwaysOpen={true}>
                    <SidebarRow 
                        text={t('buttonViewHistory')} 
                        style={`border`} 
                        onClick={() => openDialog('storage_history')}
                        icon={<HistoryIcon />}
                    />
                </SidebarGroup>
            </RightSidebar>
        </>
    )
}

export default RightSidebarStorage

